import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';
import FileView from '../../../Investments/modal/FileView';

const KeyDocuments: React.FC = () => {
    const dataRoom = useSelector((state: RootState) => state.deal.dataRoom);

    const files = useMemo(() => {
        return dataRoom.filter((d) => d.type === 'File');
    }, [dataRoom]);

    return (
        <>
            {dataRoom.length > 0 && files.length > 0 ? (
                <div className="bg-[#ffff] px-6 py-4 border border-[#27AE60] md:ml-4">
                    <div>
                        <p className="text-lg text-[#0F2240] font-[WorkSans-Bold] font-bold uppercase">
                            Key Initial Documents
                        </p>
                        <p className="text-xs text-[#20222B] font-[Lato]">[Level 1 data room to all investors]</p>
                    </div>
                    <div className="pt-4">
                        {files.map((f, i) => {
                            return (
                                <div
                                    key={`${f.dealUUID}_${i}_${f.uuid}`}
                                    className="bg-[#F1F7FF] px-4 py-3 mb-2 flex justify-between"
                                >
                                    <p className="font-[WorkSans-Semibold] font-bold text-[#000000] text-xs">
                                        {f.name}
                                    </p>
                                    <div className="flex items-center">
                                        <FileView
                                            docUUID={f.uuid}
                                            fileName={f.name}
                                            pageType="dataRoom"
                                            dealUUID={f.dealUUID}
                                            rootUUID={f.parentUUID || f.uuid}
                                            list={files}
                                            group={f.group}
                                            isDownload={
                                                (f.name || '').substring((f.name || '').lastIndexOf('.') + 1) === 'pdf'
                                                    ? f.isDownloadable
                                                    : false
                                            }
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default KeyDocuments;
